import { Component, computed, ElementRef, inject, input, viewChild } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { TranslateModule } from '@ngx-translate/core';
import { CipoImgBase64 } from '@shared/components/img-base64/common';
import { SeeMoreComponent } from '@shared/components/see-more/see-more.component';
import { UserStore } from '@signal-store';
import { UserProfileInfoFormService } from '../user-profile-info-form/user-profile-info-form.service';

@Component({
  selector: 'cipo-user-profile-header',
  imports: [SeeMoreComponent, FlexLayoutModule, CipoImgBase64, TranslateModule, MatIcon],
  templateUrl: './user-profile-header.component.html',
  styleUrl: './user-profile-header.component.scss',
})
export class UserProfileHeaderComponent {
  private readonly userProfileInfoFormService = inject(UserProfileInfoFormService);
  userStore = inject(UserStore);

  profileImageSrc = input<string>();
  firstName = input<string>();
  lastName = input<string>();
  email = input<string>();
  organizationName = input<string>();
  roles = input<string[]>();
  maxRoles = input<number>(3);
  displayFonts = input<'default' | 'small'>();
  enableProfileUpload = input<boolean>(false);

  fileInput = viewChild<ElementRef<HTMLInputElement>>('fileInput');
  small = computed(() => this.displayFonts() === 'small');

  copyEmailToClipboard() {
    if (!this.email()) return;
    navigator.clipboard.writeText(this.email() || '');
  }

  triggerFileInput() {
    if (this.enableProfileUpload()) {
      this.fileInput().nativeElement.click();
    }
  }

  onProfileImageSelected(event: Event) {
    const input = event.target as HTMLInputElement;

    if (!input.files || input.files.length === 0) {
      return;
    }

    // the profile image will be uploaded immediately after selection
    // when user store will be refreshed the new image will be displayed
    const file = input.files[0];
    this.userProfileInfoFormService.uploadUserLogo(file).subscribe(() => this.userStore.refreshUserData());
  }
}
